import type { FC } from 'react';

import { useAtomValue } from 'jotai';

import {
  hasAudioActivityAtom,
  monitoringStreamAtom,
  previewAudioStreamAtom,
} from '../../atoms/recording';

/**
 * Status text aligned with LargeMicVisualizer: same notion of "active"
 * (stream active + debounced audio activity) and same two-state copy.
 * Uses the same stream as VoiceCard (monitoringStream || previewAudioStream).
 */
export const DeviceStatusIndicator: FC = () => {
  const monitoringStream = useAtomValue(monitoringStreamAtom);
  const previewAudioStream = useAtomValue(previewAudioStreamAtom);
  const hasAudioActivity = useAtomValue(hasAudioActivityAtom);

  const stream = monitoringStream || previewAudioStream;
  const isStreamActive = stream?.active === true;
  const isActive = isStreamActive && hasAudioActivity;

  return (
    <div
      className="vai-flex vai-flex-col vai-items-end vai-text-right vai-gap-1 vai-w-[240px] vai-min-w-[240px] vai-max-w-[240px]"
      data-testid="device-status-indicator"
    >
      {isActive ? (
        <>
          <span
            className="vai-text-sm vai-font-semibold vai-text-leaf-700"
            data-testid="microphone-connected-text"
          >
            Microphone connected.
          </span>
          <span
            className="vai-text-xs vai-text-slate-500"
            data-testid="ready-to-record-text"
          >
            Ready to record!
          </span>
        </>
      ) : (
        <>
          <span
            className="vai-text-sm vai-font-semibold vai-text-red-600"
            data-testid="no-microphone-text"
          >
            No active microphone found.
          </span>
          <span className="vai-text-xs vai-text-slate-500">
            Say something to activate the mic. If it&apos;s not responding,
            choose another mic.
          </span>
        </>
      )}
    </div>
  );
};
